import React from "react";
import { Box, Tabs, Tab, Stack,Button, Grid } from "@mui/material";
import { useState } from "react";
import TabPanel from "../../../components/TabPanel";
import { getTransactionDocRelatedRecords } from "../../../api/transaction-type";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  billRelatedRecordsPayment,
  billRelatedRecordsPurchaseOrder,
  billRelatedRecordsReimbursements,
  billRelatedRecordsTransformations,
} from "../../../config/grid-column-defs";
import useSnackbar from "../../../hooks/useSnackbar";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";
import AgGridNonPaginatedTable from "../../../components/AgGridNonPaginatedTable";
import BillsPrintViewDialog from "../../../components/Printdialog";

export default function BillRelatedRecords({rowData}) {
  /*----------------Tabs-----------------*/
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
 const [TableData, setTableData] = useState([]);
 const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
 
  async function getTransactionRelatedRecordsData(limit, offset) {
    setId(params.docNo);
    try {
      const { data } = await getTransactionDocRelatedRecords(user.token, {
        id: params.docNo,
        limit, offset,
      });
      setTableData(data?.data);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Box className="viewDetilsBox">
        <Tabs
          value={tabIndexRelatedRecord}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndexRelatedRecord(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-sub-bkg"
        >
          <Tab label="Payments" />
          <Tab label="Purchase Order" />
          <Tab label="Reimbursements" />
          <Tab label="Transformations" />
        </Tabs>

        {/* Payments */}
        <TabPanel value={tabIndexRelatedRecord} index={0}>
        <Box
            sx={{
              backgroundColor: "#bbd9e8",
              p: 1,
            }}
          >
            <Stack spacing={2} direction="row">
              <Button className="blue-button"  onClick={() => {setOpen(true)}}>Print</Button>
          </Stack>
          </Box>
          <AgGridNonPaginatedTable
            getTableRows={getTransactionRelatedRecordsData}
            columns={billRelatedRecordsPayment}
            refreshCounter={0}
            perPage={5}
          />
         <div className="m-b-10" style={{ border: "1px solid" }}>
                     <Grid container spacing={2}>
                       <Grid item xs={12} sm={3} md={3} className="m-b-10">
                         <p className="tFormlabel" style={{ textAlign: "end" }}>
                           Total
                         </p>
                       </Grid>
                       <Grid item xs={12} sm={4} md={4} className="m-b-10">
                        
                       </Grid>
                       <Grid item xs={12} sm={5} md={5} className="m-b-10">
                         <p className="tFormName" style={{ textAlign: "end" }}>{TableData?.totalsum}</p>
                       </Grid>
                     </Grid>
                   </div>
        </TabPanel>

        {/* Purchase Order */}
        <TabPanel value={tabIndexRelatedRecord} index={1}>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={billRelatedRecordsPurchaseOrder}
            refreshCounter={0}
          />
        </TabPanel>

        {/* Reimbursements */}
        <TabPanel value={tabIndexRelatedRecord} index={2}>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={billRelatedRecordsReimbursements}
            refreshCounter={0}
          />
        </TabPanel>

        {/* Transformations */}
        <TabPanel value={tabIndexRelatedRecord} index={3}>
          <AgGridPaginatedTable
            getTableRows={undefined}
            columns={billRelatedRecordsTransformations}
            refreshCounter={0}
          />
        </TabPanel>
        <BillsPrintViewDialog open={open} id={id} rowData={rowData}  handleClose={handleClose} />
      </Box>
    </>
  );
}
